import { initStay, destoryStayPopup } from 'common/utils/stayDialog';
import myPerformance from 'common/utils/myPerformance';
var whitelist = ['loanGuide', 'checkMobile', 'statuteCase', 'overdueImpact', 'privacyfile', 'page-protocol', 'downloadGuide', 'downloadPage']; //白名单列表

export default {
  created: function created() {
    // 记录页面访问时间戳
    window._pageTimeStamps = Date.now();
    // 隐藏loading元素
    var loadingDOM = document.querySelector('#PageLoading');
    if (loadingDOM && loadingDOM.style) {
      loadingDOM.style.display = 'none';
    }
  },
  methods: {
    pageBeforeCreate: function pageBeforeCreate() {
      myPerformance.pageBeforeCreate();
    },
    pageMounted: function pageMounted() {
      var _this = this;
      myPerformance.pageMounted();
      myPerformance.pageLoadingToastEnd();
      setTimeout(function () {
        var name = _this.$route.name;
        if (!whitelist.includes(name)) {
          // initStay(this.$route);
        }
      }, 500);
    },
    adReachDestroy: function adReachDestroy() {
      destoryStayPopup();
    }
  }
};
const __FLY_DATA_ = {};